import React, { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Flex } from 'onefaceui-react-components';
import { fromJS } from 'immutable';

import { actionCreators } from 'react/api/actions/taskScheduler';
import { getResourceTo } from 'react/utils/utils';

function TaskSchedulerActions(props) {
  const { item, index } = props;

  const dispath = useDispatch();
  const isExecuting = useSelector((state) => state.taskScheduler.getIn(['taskSchedulers', index, 'isExecuting'], false));

  const executeScheduler = () => {
    dispath(actionCreators.executeTaskScheduler({ executingId: item.id, executingIndex: `${index}` }));
  };

  const checkSchedulerLogs = () => {
    dispath(actionCreators.requestTaskSchedulerLogs({ activeLog: fromJS(item) }));
  };

  if (isExecuting) {
    return (
      <Flex
        style={{ flex: 1 }}
        alignItems="center"
        justifyContent="center"
      >
        <div className="executeSchedulerSpinner">
          <div></div><div></div><div></div>
        </div>
      </Flex>
    );
  }

  return (
    <Flex
      style={{ flex: 1 }}
      alignItems="center"
      justifyContent="center"
      gap={16}
    >
      <div
        className="actionIcon executeScheduler"
        title={getResourceTo('TaskScheduler.action.execute')}
        onClick={executeScheduler}
      >
        <i className="fa fa-play-circle"></i>
      </div>
      <div
        className="actionIcon checkSchedulerLogs"
        title={getResourceTo('TaskScheduler.action.seeLogs')}
        onClick={checkSchedulerLogs}
      >
        <i className="fa fa-wpforms"></i>
      </div>
    </Flex>
  );
}

export default memo(TaskSchedulerActions);
